<template>
  <div
    class="transition-all duration-300"
    :class="[showing ? 'h-15' : 'h-0']"
    :style="{ width: 'calc(100vw - 0.5rem)' }"
  >
    <div
      v-if="clientTargetJob"
      class="h-15 px-6 rounded-b flex items-center justify-between gap-2"
      :class="[wasCompletedButHasFailed ? 'bg-pending-100' : 'bg-success-100']"
    >
      <div class="flex items-center gap-2">
        <div
          class="h-10 w-10 flex-shrink-0 grid place-items-center"
          :style="{
            background: wasCompletedButHasFailed ? '#F7E5AA' : '#D1FAA1',
            borderRadius: '0.25rem'
          }"
        >
          <BlIcon
            v-if="wasCompletedButHasFailed"
            icon="warning"
            color="pending-4"
            class="h-6 w-6"
          />
          <BlIcon
            v-else-if="clientTargetJob.status === 'completed'"
            icon="check-circle"
            color="success"
            class="h-6 w-6"
          />
          <BlIcon
            v-else
            icon="update"
            color="success"
            class="w-6 animate-spin"
          />
        </div>
        <div class="flex flex-col">
          <BlTextBody2
            v-if="wasCompletedButHasFailed"
            class="text-pending"
            text="Some targets were not successfully added. Please review and retry for the unsuccessful targets."
          />
          <BlTextBody2
            v-else-if="clientTargetJob.status === 'completed'"
            class="text-success"
            text="The process of adding targets to the client from the databank is complete. You can now resume adding new targets."
          />
          <BlTextBody2
            v-else
            class="text-success"
            text="Targets are currently being added to the client from the databank. Please wait until the process is complete to add new targets."
          />
          <div
            v-if="
              clientTargetJob.status === 'completed' ||
                clientTargetJob.status === 'canceled'
            "
            class="flex items-center gap-2"
          >
            <BlTextSubtitle3
              :class="[
                wasCompletedButHasFailed ? 'text-pending' : 'text-success'
              ]"
              :text="
                `Successful targets added: ${clientTargetJob.total_success}`
              "
            />
            <div
              :class="[
                wasCompletedButHasFailed ? 'bg-pending-300' : 'bg-success-300'
              ]"
              class="h-1 w-1 rounded-full"
            />
            <BlTextSubtitle3
              :class="[
                wasCompletedButHasFailed ? 'text-pending' : 'text-success'
              ]"
              :text="`Failed targets: ${clientTargetJob.total_errors}`"
            />
          </div>
          <BlTextSubtitle3
            v-else
            class="text-success"
            :text="`Remaining targets: ${clientTargetJob.remaining_targets}`"
          />
        </div>
      </div>
      <div
        v-if="
          clientTargetJob.status === 'in_progress' ||
            clientTargetJob.status === 'pending'
        "
      >
        <button
          class="outline-none border border-lime-500 rounded flex items-center justify-center h-8 px-4"
          :class="
            cancelLoading
              ? 'bg-grey-100 cursor-wait'
              : 'bg-pure-white hover:bg-grey-200 cursor-pointer'
          "
          :disabled="cancelLoading"
          @click.prevent="onCancelJob"
        >
          <label
            class="font-semibold text-sm text-lime-700 tracking-wide"
            :class="cancelLoading ? 'cursor-wait' : 'cursor-pointer'"
          >
            Cancel import
          </label>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import BlIcon from "../../BlIcon.vue";
import BlInputButton from "../../BlInputButton.vue";
import BlTextBody2 from "../../BlTextBody2.vue";
import BlTextSubtitle3 from "../../BlTextSubtitle3.vue";

export default {
  name: "TargetJobProgression",
  components: { BlIcon, BlTextBody2, BlTextSubtitle3, BlInputButton },
  data() {
    return {
      currentJobId: "",
      showing: false,
      cancelLoading: false
    };
  },
  computed: {
    ...mapGetters(["client", "clientTargetJob"]),
    wasCompletedButHasFailed() {
      if (!this.clientTargetJob) return false;
      const status = this.clientTargetJob.status;
      return (
        (status === "completed" && this.clientTargetJob.total_errors) ||
        status === "canceled"
      );
    }
  },
  watch: {
    clientTargetJob(val) {
      this.setup(val);
    }
  },
  mounted() {
    this.setup(this.clientTargetJob);
  },
  methods: {
    ...mapActions(["cancelTargetJob"]),
    setup(val) {
      const clientId = this.client ? this.client.id : null;
      if (val && val.client_id === clientId) {
        if (this.currentJobId !== val.job_id) {
          this.showing = true;
        }
        if (val.status === "completed" || val.status === "canceled") {
          setTimeout(() => {
            this.showing = false;
          }, 5000);
        }
        this.currentJobId = val.job_id;
      }
    },
    onCancelJob() {
      this.cancelLoading = true;
      const data = { job_id: this.clientTargetJob.job_id };
      this.cancelTargetJob(data).then(({ success }) => {
        this.cancelLoading = false;
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/clients/target/TargetJobProgression.vue